var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ubi-browser-context',[(_vm.isAuthenticating)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"App-loading"}):_c('router-view',{key:_vm.getLangage})],1)}
var staticRenderFns = []

export { render, staticRenderFns }